import { render, staticRenderFns } from "./Fichaje.vue?vue&type=template&id=3254b8e4&scoped=true&"
import script from "./Fichaje.vue?vue&type=script&lang=js&"
export * from "./Fichaje.vue?vue&type=script&lang=js&"
import style0 from "./Fichaje.vue?vue&type=style&index=0&id=3254b8e4&prod&lang=scss&scoped=true&"
import style1 from "./Fichaje.vue?vue&type=style&index=1&id=3254b8e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254b8e4",
  null
  
)

export default component.exports